import React from "react";
import { Box } from "@mui/material";

const PageShell = ({ children }) => (
  <Box className="page-shell" sx={{ width: "100%" }}>
    {children}
  </Box>
);

export default PageShell;
